import {Button} from '@dropbox/dig-components/buttons';
import {Menu} from '@dropbox/dig-components/menu';
import {Text} from '@dropbox/dig-components/typography';
import {ANALYTICS_EVENTS, sendAnalyticsEvent} from 'utilities/analytics';

import {getSpritesYear, useFeedbackCycles} from './sprites_cycle_selector';

type CycleDropdownProps = {
  dropboxerId: string;
};

export const CycleDropdown = ({dropboxerId}: CycleDropdownProps) => {
  const {sortedSpritesCycles, selectedSpritesCycle, handleSetSpritesCycle} =
    useFeedbackCycles(dropboxerId);

  const handleCycleSelect = (cycle: string) => {
    handleSetSpritesCycle(cycle);
    sendAnalyticsEvent(
      ANALYTICS_EVENTS.MANAGER_ASSISTANT.SPRITES_CYCLE_SELECTED,
      {
        category: 'Manager Assistant',
      }
    );
  };

  const buttonLabel = selectedSpritesCycle || 'Select Cycle';

  return (
    <Menu.Wrapper onSelection={(value: string) => handleCycleSelect(value)}>
      {({getContentProps, getTriggerProps}) => (
        <>
          <Button
            variant="outline"
            size="medium"
            {...getTriggerProps()}
            style={{backgroundColor: '#0061FF'}}
          >
            <Text
              size="small"
              style={{
                color: '#FFFFFF',
                fontWeight: 600,
              }}
            >
              ❯&nbsp;&nbsp;{buttonLabel}
            </Text>
          </Button>
          <Menu.Content {...getContentProps()} placement="bottom-end">
            <Menu.Segment>
              {sortedSpritesCycles.map((cycle) => {
                const year = getSpritesYear(cycle);
                return (
                  <Menu.SelectItem
                    key={cycle}
                    value={cycle}
                    selected={selectedSpritesCycle === cycle}
                    withTitle={cycle}
                    withLeftAccessory={
                      <Text size="small" isBold>
                        {year?.slice(-2)}
                      </Text>
                    }
                  />
                );
              })}
            </Menu.Segment>
          </Menu.Content>
        </>
      )}
    </Menu.Wrapper>
  );
};
